var searchI18n = {
  clear: 'Clear',
  showingResult: 'Showing %s result',
  showingResults: 'Showing %s results'
};
export default searchI18n;